<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
  <app-section-header
    *ngIf="showHeader"
    [title]="'technician-data.connection-type-title' | translate"
    [tooltip]="'tooltips.technician-form.connection-type-title' | translate"
    [showTooltip]=""
    tooltipStyleClass="base-data-tooltip"
    tooltipPosition="bottom"></app-section-header>
</div>

<form [formGroup]="form">
  <div class="power-connection-type-section ui-g-12 top-margin form-section form-font-size">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
      <p-radioButton
        [value]="powerConnectionTypes[0].value"
        formControlName="powerConnectionType"
        id="power-connection-checkbox"
        label="{{ 'lookup.' + powerConnectionTypeKey + '.options.' + powerConnectionTypes[0].value + '.name' | translate }}"
        name="power-connection-group"></p-radioButton>
      <div *ngIf="showPowerConnectionInfo1">
        <p-card>{{ 'basic-profile.jurisdiction.power-connection-type-info-1' | translate }}</p-card>
      </div>
    </div>
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
      <p-radioButton
        [value]="powerConnectionTypes[1].value"
        formControlName="powerConnectionType"
        id="power-connection-checkbox"
        label="{{ 'lookup.' + powerConnectionTypeKey + '.options.' + powerConnectionTypes[1].value + '.name' | translate }}"
        name="power-connection-group"></p-radioButton>
    </div>
  </div>
</form>
